import React from 'react'

import styled from 'styled-components'

// IUIListStyles
interface IUIListStyles {
  children: React.ReactNode
  margin?: string
  gap?: string
}

const UIListWrapper = styled.ul<IUIListStyles>`
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: ${props => props.margin};
  padding: 0;
  width: 100%;
  max-width: 100%;
  gap: ${props => props.gap};
`

const UIList = ({
  children,
  margin = '0',
  gap = '1rem',
  ...styles
}: IUIListStyles) => {
  return (
    <UIListWrapper {...styles} gap={gap} margin={margin}>
      {children}
    </UIListWrapper>
  )
}

export default UIList
